import React from 'react';
import { useAppSelector } from 'store/hooks';

import { currentStudentSelector } from 'store/student/selectors';

import GrantProAccess from './GrantProAccess';

const GrantProAccessContainer = ({
  open,
  schoolId,
  onClose,
  ...restProps
}: { open: any; schoolId: string; onClose: any } & Record<string, any>) => {
  const currentStudent = useAppSelector(currentStudentSelector);

  if (!currentStudent) {
    return null;
  }

  const handleGiveAccessClick = (values: any) => {
    console.log('Values', values);
    onClose();
  };

  const courses = currentStudent.courses.filter(
    (course: any) => course.schoolId === schoolId,
  );

  return (
    <GrantProAccess
      open={open}
      courses={courses}
      onClose={onClose}
      currentStudent={currentStudent}
      onGiveAccess={handleGiveAccessClick}
    />
  );
};

export default React.memo(GrantProAccessContainer) as any;
